import { useState } from "react";
import { Link } from "react-router-dom";
import NetworkGraph from "../../components/NetworkGraph";
import Reveal from "../../components/Reveal";
import { IconCloud } from "../../components/Icons";

const ACCENT = "#0091FF";

const FAQS = [
  {
    question: "O sepolDRIVE é mais seguro que Google Drive?",
    answer:
      "Sim, em termos de privacidade. No sepolDRIVE seus dados ficam em servidor dedicado à sua empresa. Para empresas com requisitos de conformidade (LGPD, sigilo comercial), é a escolha mais adequada.",
  },
  {
    question: "Funciona como o Google Drive no dia a dia?",
    answer:
      "Sim. Tem aplicativo para Windows, Mac, Android e iPhone com sincronização automática — igual ao Google Drive, só que com privacidade total.",
  },
  {
    question: "Posso migrar meus arquivos do Google Drive?",
    answer:
      "Sim. A sepolTECH realiza a migração dos seus arquivos de qualquer plataforma para o sepolDRIVE.",
  },
];

const FEATURES = [
  {
    title: "Nuvem 100% Privada",
    desc: "Seus dados em infraestrutura dedicada, sem compartilhamento com terceiros",
  },
  {
    title: "Compartilhamento Seguro",
    desc: "Links protegidos por senha e com data de validade",
  },
  {
    title: "Colaboração em Equipe",
    desc: "Pastas colaborativas e edição simultânea de documentos",
  },
  {
    title: "App Mobile & Desktop",
    desc: "Sincronização automática em Windows, Mac, Android e iPhone",
  },
  {
    title: "Controle de Acessos",
    desc: "Permissões granulares por usuário ou grupo",
  },
  {
    title: "Gestão pela sepolTECH",
    desc: "Monitoramento, atualizações e suporte incluídos",
  },
];

export default function SepolDrive() {
  const [openFaq, setOpenFaq] = useState(null);

  const toggleFaq = (index) => {
    setOpenFaq((prev) => (prev === index ? null : index));
  };

  return (
    <>
      {/* ═══════════════ ABERTURA ═══════════════ */}
      <section className="page-hero">
        <div className="page-hero__bg"></div>
        <div className="page-hero__grid"></div>
        <NetworkGraph variant="hero" className="page-hero__network" />
        <div className="container">
          <div className="breadcrumb animate-up">
            <Link to="/">Início</Link>
            <span>/</span>
            <Link to="/produtos/produtos">Produtos</Link>
            <span>/</span>
            <span>sepolDRIVE</span>
          </div>
          <div className="tag animate-up animate-up--d1" style={{ color: ACCENT, background: "rgba(0,145,255,.12)", borderColor: `${ACCENT}40` }}>
            <IconCloud style={{ width: "13px", height: "13px" }} />
            Private Cloud · Nextcloud
          </div>
          <h1
            className="animate-up animate-up--d2"
            style={{
              fontFamily: "var(--font-display)",
              fontSize: "clamp(40px,6vw,72px)",
              fontWeight: 700,
              letterSpacing: "-.03em",
              lineHeight: "1.05",
              marginBottom: "24px",
              color: "var(--text-primary)",
            }}
          >
            sepol<span style={{ color: ACCENT }}>DRIVE</span>
          </h1>
          <p
            className="animate-up animate-up--d3"
            style={{
              fontSize: "18px",
              color: "var(--text-secondary)",
              maxWidth: "540px",
              lineHeight: "1.7",
              marginBottom: "40px",
            }}
          >
            Nuvem privada com Nextcloud. Seus dados no seu servidor —
            privacidade e controle totais, sem o Google ou Microsoft no meio
            do caminho.
          </p>
          <div className="hero-actions-col animate-up animate-up--d4">
            <Link to="/contato" className="btn btn-primary">
              Contratar sepolDRIVE →
            </Link>
            <Link to="/contato" className="btn btn-outline">
              Falar com especialista
            </Link>
          </div>
        </div>
      </section>

      {/* ═══════════════ RECURSOS INCLUSOS ═══════════════ */}
      <section className="section">
        <div className="container">
          <Reveal>
            <div className="tag" style={{ color: ACCENT, background: "rgba(0,145,255,.12)", borderColor: `${ACCENT}40` }}>
              Recursos inclusos
            </div>
            <h2 className="section-title" style={{ marginBottom: "36px" }}>
              O que você recebe com <span style={{ color: ACCENT }}>sepolDRIVE</span>
            </h2>
            <div className="feature-list">
              {FEATURES.map((feature) => (
                <div className="feature-item" key={feature.title}>
                  <div
                    className="feature-item__icon"
                    style={{ background: "rgba(0,145,255,.12)", color: ACCENT }}
                  >
                    ✓
                  </div>
                  <div>
                    <strong style={{ color: "var(--text-primary)" }}>{feature.title}</strong> —{" "}
                    {feature.desc}
                  </div>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </section>

      {/* ═══════════════ FAQ ═══════════════ */}
      <section className="section section--alt">
        <div className="container" style={{ maxWidth: "760px" }}>
          <Reveal className="text-center" style={{ marginBottom: "40px" }}>
            <div className="tag" style={{ color: ACCENT, background: "rgba(0,145,255,.12)", borderColor: `${ACCENT}40` }}>
              FAQ
            </div>
            <h2 className="section-title">
              Dúvidas sobre <span style={{ color: ACCENT }}>sepolDRIVE</span>
            </h2>
          </Reveal>

          {FAQS.map((faq, index) => (
            <Reveal
              className={`faq-item${openFaq === index ? " open" : ""}`}
              delay={index * 0.05}
              key={faq.question}
            >
              <button
                className="faq-btn"
                onClick={() => toggleFaq(index)}
                aria-expanded={openFaq === index}
              >
                {faq.question}
                <span className="faq-btn__icon">+</span>
              </button>
              <div className="faq-answer">
                <p>{faq.answer}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      {/* ═══════════════ CTA ═══════════════ */}
      <section className="section">
        <div className="container">
          <Reveal className="cta-banner">
            <h2 className="cta-banner__title">
              Seus dados merecem privacidade de verdade
            </h2>
            <p className="cta-banner__sub">
              Substitua o Google Drive e OneDrive por uma nuvem privada sob o
              controle da sua empresa.
            </p>
            <div className="cta-banner__actions">
              <Link to="/contato" className="btn btn-primary">
                Contratar sepolDRIVE →
              </Link>
              <Link to="/produtos/produtos" className="btn btn-outline">
                Ver outros produtos
              </Link>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
